export const handleValidity = ({ target }) => {
  const message = target.dataset.message;
  target.setCustomValidity(message);
};

export const handleInput = ({ target }) => {
  target.setCustomValidity('');
};
